import React, { useEffect, useState } from 'react';
import LineChart from '../components/chart/LineChart';
import BarChart from '../components/chart/BarChart';
import MapChart from '../components/chart/MapChart';
import PieChart from '../components/chart/PieChart';
import TableChart from '../components/chart/TableChart';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import Axios from 'axios';
import { API_INSIGHT } from '../api/api';
import ClipLoader from 'react-spinners/ClipLoader';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { CONFIG_AUTH } from '../utils/API';
import LIST_AUCTION_CITY from '../constant/auction-city';
import VEHICLE_YEAR from '../constant/vehicle-year';
import LIST_TRANSMISSION_VEHICLE from '../constant/transmission-vehicle';
import LIST_GRADE_VEHICLE from '../constant/grade-vehicle';
import LIST_BRAND_VEHICLE from '../constant/brand-vehicle';
import LIST_CYLINDER_VEHICLE from '../constant/cylinder-vehicle';
import LIST_SERIES_VEHICLE from '../constant/series-vehicle';
import LIST_TYPE_VEHICLE from '../constant/type-vehicle';

const InsightWidget = ({ data, deleteWidget, setSelectedWidget, openEditor, setOpenEditor }) => {
  const [loading, setLoading] = useState(true);
  const [chart, setChart] = useState({
    type: data.chartType,
    metric: data.metric,
    result: [],
  });

  const getChart = (chart) => {
    switch (chart.type) {
      case 0:
        return <LineChart data={chart} />;
      case 1:
        return <BarChart data={chart} />;
      case 2:
        return <PieChart data={chart} />;
      case 3:
        return <TableChart data={chart} />;
      case 4:
        return <MapChart data={chart} />;
    }
  };

  const color = [
    '#074c89',
    '#564887',
    '#b85382',
    '#f05377',
    '#f0a18c',
    '#7C7C16',
    '#052B05',
    '#4ec04e',
    '#d8d836',
    '#51d836',
    '#a6c34c',
    '#fec84c',
    '#f48847',
    '#eb4841',
    '#ff4e00',
    '#F2840A',
    '#DEC218',
    '#C3D120',
    '#81be2a',
  ];
  const regionList = [
    'id-indo',
    'id-aceh',
    'id-kaltim',
    'SEMARANG',
    'id-bengkulu',
    'BANTEN',
    'id-kalbar',
    'id-belitung',
    'BALI',
    'SURABAYA',
    'id-kalsel',
    'id-ntt',
    'MAKASSAR',
    'id-kriau',
    'id-irian',
    'MEDAN',
    'PEKANBARU',
    'id-sulut',
    'id-malut',
    'id-sumbar',
    'id-maluku',
    'id-ntb',
    'id-sultra',
    'id-sulteng',
    'id-papua',
    'BANDUNG',
    'LAMPUNG',
    'JAKARTA',
    'id-gorontalo',
    'id-yogya',
    'id-kalteng',
    'PALEMBANG',
    'id-sulbar',
    'JAMBI',
  ];

  const processData = (rawData, type) => {
    let result = [];
    let max;

    if (type === 0) {
      rawData.map((row, idx) => { });
      result = rawData.map((row, idx) => ({
        name: row.name,
        data: row.data.map((d) => (d > 0 ? d : null)),
        color: color[idx],
      }));
      let values = [];
      for (let i = 0; i < rawData.length; i++) {
        values = [...values, rawData[i].data.length];
      }
      max = Math.max(...values);
      // Bar Data Maping
    } else if (type === 1) {
      result = rawData.map(({ name, data }, i) => ({
        name: name,
        data: [Math.floor(data)],
        color: color[4 - i],
      }));
      max = Math.max(...rawData.map((e) => e.data));
      // Pie Data Maping
    } else if (type === 2) {
      let other = 100.0;
      result = rawData.map(({ name, data, percentage }, i) => {
        const value = parseFloat(percentage);
        other -= value;
        return {
          name: name,
          y: value,
          color: color[4 - i],
        };
      });
      max = Math.max(...rawData.map((e) => e.percentage));
      result.push({
        name: 'Mobil Lainnya',
        y: other,
        color: color[result.length % 5],
        visible: false,
      });
      // Table Data Maping
    } else if (type === 3) {
      result = rawData.map((row, idx) => ({
        merek: row.brand,
        seri: row.series,
        silinder: row.cylinder,
        tipe: row.type,
        tahun: row.year,
        transmisi: row.transmission,
        kota: row.city === '-' ? 'Semua Kota' : row.city,
        grade: row.grade === '-' ? 'Semua Grade' : row.grade,
        harga: row.price,
      }));
      max = Math.max(...rawData.map((e) => e.price));
      // Geomap Data Maping
    } else if (type === 4) {
      result = regionList.map((city) => ({
        'hc-key': city,
        value: Math.max(
          ...rawData.map((car) => {
            const data = car.data.find((e) => e.city === city) || { value: 0 };
            return data.value;
          })
        ),
        values: rawData.map((car) => {
          const data = car.data.find((e) => e.city === city) || { value: 0 };
          return {
            name: car.name,
            value: data.value,
          };
        }),
      }));
      let values = [];
      for (let i = 0; i < rawData.length; i++) {
        values = [...values, ...rawData[i].data.map((e) => e.value)];
      }
      max = Math.max(...values);
    }

    if (max <= 0) {
      result = null;
    }

    return result;
  };

  useEffect(() => {
    let temp_filter = data.filters.map((filter) => ({
      cylinder:
        LIST_CYLINDER_VEHICLE.filter((cylinder) => cylinder.key == (filter.hasOwnProperty('cylinder') ? filter.cylinder : ''))
          .length > 0
          ? LIST_CYLINDER_VEHICLE.filter(
            (cylinder) => cylinder.key == (filter.hasOwnProperty('cylinder') ? filter.cylinder : '')
          )[0].value
          : filter.cylinder,
      brand:
        LIST_BRAND_VEHICLE.filter((brand) => brand.key == (filter.hasOwnProperty('brand') ? filter.brand : '')).length > 0
          ? LIST_BRAND_VEHICLE.filter((brand) => brand.key == (filter.hasOwnProperty('brand') ? filter.brand : ''))[0].value
          : filter.brand,
      city:
        LIST_AUCTION_CITY.filter((city) => city.key == (filter.hasOwnProperty('city') ? filter.city : '')).length > 0
          ? LIST_AUCTION_CITY.filter((city) => city.key == (filter.hasOwnProperty('city') ? filter.city : ''))[0].value
          : filter.city,
      grade:
        LIST_GRADE_VEHICLE.filter((grade) => grade.key == (filter.hasOwnProperty('grade') ? filter.grade : '')).length > 0
          ? LIST_GRADE_VEHICLE.filter((grade) => grade.key == (filter.hasOwnProperty('grade') ? filter.grade : ''))[0].value
          : filter.grade,
      series:
        LIST_SERIES_VEHICLE.filter((series) => series.key == (filter.hasOwnProperty('series') ? filter.series : '')).length >
          0
          ? LIST_SERIES_VEHICLE.filter((series) => series.key == (filter.hasOwnProperty('series') ? filter.series : ''))[0]
            .value
          : filter.series,
      transmission:
        LIST_TRANSMISSION_VEHICLE.filter(
          (transmission) => transmission.key == (filter.hasOwnProperty('transmission') ? filter.transmission : '')
        ).length > 0
          ? LIST_TRANSMISSION_VEHICLE.filter(
            (transmission) => transmission.key == (filter.hasOwnProperty('transmission') ? filter.transmission : '')
          )[0].value
          : filter.transmission,
      type:
        LIST_TYPE_VEHICLE.filter((type) => type.key == (filter.hasOwnProperty('type') ? filter.type : '')).length > 0
          ? LIST_TYPE_VEHICLE.filter((type) => type.key == (filter.hasOwnProperty('type') ? filter.type : ''))[0].value
          : filter.type,
      year:
        VEHICLE_YEAR.filter((year) => year.key == (filter.hasOwnProperty('year') ? filter.year : '')).length > 0
          ? VEHICLE_YEAR.filter((year) => year.key == (filter.hasOwnProperty('year') ? filter.year : ''))[0].value
          : filter.year,
    }));

    Axios.post(
      API_INSIGHT.insight,
      { chartType: data.chartType, metric: data.metric, period: data.period, filters: JSON.stringify(temp_filter) },
      {
        headers: {
          ...CONFIG_AUTH,
        },
      }
    )
      .then((res) => {
        const data = res.data.data;

        setChart({ ...chart, result: data });
      })
      .catch((err) => { })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <>
      <div className="col-xl-6 mt-4 insight-widget">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h6 className="mt-2">{data.name}</h6>
            <div>
              <button className="btn">
                <FontAwesomeIcon
                  className="text-light"
                  icon={faTimes}
                  onClick={() => {
                    deleteWidget({ data });
                  }}
                />
              </button>
            </div>
          </div>
          <div className="card-body">
            {loading ? (
              <div style={{ textAlign: 'center' }}>
                <ClipLoader loading size={100} />
              </div>
            ) : processData(chart.result, chart.type) === null ? (
              <div className="row">
                <div className="col-xl-12 text-center bg-light" style={{ paddingTop: 80, paddingBottom: 80 }}>
                  <p>
                    <FontAwesomeIcon icon={faExclamationCircle} style={{ fontSize: 40, color: '#777777' }} />
                  </p>
                  <span style={{ color: '#777777', fontSize: 25 }}>Data Tidak Ditemukan !</span>
                </div>
              </div>
            ) : (
              getChart(chart)
            )}
          </div>
        </div>
      </div>
      <div className="insight-widget-mobile mb-4 bg-white">
        <div className="d-flex flex-column">
          <div
            className="px-3 py-2 d-flex flex-row justify-content-between align-items-center"
            style={{ backgroundColor: '#82be2a', borderTopLeftRadius: 8, borderTopRightRadius: 8 }}
          >
            <h6 className="text-white">{data.name}</h6>
            <div>
              <button className="btn">
                <FontAwesomeIcon
                  className="text-light"
                  icon={faTimes}
                  onClick={() => {
                    deleteWidget({ data });
                  }}
                />
              </button>
            </div>
          </div>
          <div className="p-2" style={{ width: '90vw' }}>
            {loading ? (
              <div style={{ textAlign: 'center' }}>
                <ClipLoader loading size={100} />
              </div>
            ) : processData(chart.result, chart.type) === null ? (
              <div className="text-center py-5">
                <p>
                  <FontAwesomeIcon icon={faExclamationCircle} style={{ fontSize: 40, color: '#777777' }} />
                </p>
                <span style={{ color: '#777777', fontSize: 25 }}>Data Tidak Ditemukan !</span>
              </div>
            ) : (
              getChart(chart)
            )}
          </div>
          <div></div>
        </div>
      </div>
    </>
  );
};

export default InsightWidget;
